<template>
  <div class="c-interactiveRating">
    <div class="c-interactiveRating__icons">
      <StarIcon @click="changeAmount(1)" :class="{ 'icon--active': rating >= 1 }"></StarIcon>
      <StarIcon @click="changeAmount(2)" :class="{ 'icon--active': rating >= 2 }"></StarIcon>
      <StarIcon @click="changeAmount(3)" :class="{ 'icon--active': rating >= 3 }"></StarIcon>
      <StarIcon @click="changeAmount(4)" :class="{ 'icon--active': rating >= 4 }"></StarIcon>
      <StarIcon @click="changeAmount(5)" :class="{ 'icon--active': rating >= 5 }"></StarIcon>
    </div>
  </div>
</template>

<script>
import StarIcon from "@web/assets/icon/fadedStar.svg";

export default {
  name: "InteractiveRating",
  props: {
  },
  components: {
    StarIcon,
  },
  data: () => {
		return {
      rating: 0,
    };
	},
  methods:{
    changeAmount(value){
      this.rating = value
      this.$emit('update:modelValue', value);
    },
  }
};
</script>

<style lang="scss">
@import "@backend/scss/abstracts/variables.scss";
@import "@backend/scss/abstracts/mixins.scss";

.c-interactiveRating {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: -3px;
  margin-top: 4px;
  &__icons {
    display: flex;
    align-items: center;
    gap: 4px;

    svg {
      width: 22px;
      height: 22px;
      &:hover{
        cursor: pointer;
      }
    }

    .icon {
      &--active {
        path {
          transition: all 150ms ease-in;
          fill: $c-blue;
        }
      }
    }
    p {
      font-size: $font-disclaimer-size;
      line-height: $font-disclaimer-size;
      font-weight: $f-regular;
    }
  }

  &__numbers {
    display: flex;
    align-items: center;

    p {
      font-size: $font-disclaimer-size;
      line-height: $font-disclaimer-size;
      font-weight: $f-regular;
    }
  }

  &__link {
    display: flex;
    align-items: center;
    .o-link {
      font-weight: $f-bold;
    }
  }
}
</style>
